<app-header />

<section class="banner_slider">
    <div class="slider">
        <owl-carousel-o [options]="banner_slider">

            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image1.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image2.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image3.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image4.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image5.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image6.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image7.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image8.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image9.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image10.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image11.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image12.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image13.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image14.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/WhatsApp_Image15.jpeg'" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>

            <!-- <ng-template carouselSlide *ngFor="let item of HeaderSlider">
                <div>
                    <div class="banner_slider_content">
                        <div class="slider_flex">
                            <div class="left_side">
                                <img [src]="'Images/HomeHeader/' + item.ImageName" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template> -->

        </owl-carousel-o>
    </div>
</section>

<!-- bottom_section Starts -->
<div class="bottom_section">
    <div class="container">
        <div class="content">

            <!-- products_section Starts -->
            <section class="products_section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="title-box">
                                <h2 class="title">Welcome to our <span>Curtains World</span></h2>
                                <a href="#" class="btn btn-default btn-robot">view products</a>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-4">
                            <div class="product-box">
                                <img class="img-responsive" src="Images/HomeHeader/WhatsApp_Image10.jpeg" alt="product">
                                <h3 class="product-title">Magnetic Curtains</h3>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="product-box">
                                <img class="img-responsive" src="Images/HomeHeader/WhatsApp_Image13.jpeg" alt="product">
                                <h3 class="product-title">Half Curtains</h3>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="product-box">
                                <img class="img-responsive" src="Images/HomeHeader/WhatsApp_Image7.jpeg" alt="product">
                                <h3 class="product-title">Zipper Curtains</h3>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="classic-title">
                                <div class="stiker">
                                    <h3 class="inner-stiker">Why we are best</h3>
                                </div>
                                <h3 class="outer-stiker">We Received best product award in the 2018</h3>
                                <div class="incline-div"></div>
                            </div>
                        </div>
                        <div class="boxed row">
                            <div class="col-sm-4">
                                <p class="p-large">
                                    Blocks direct sunrays and keeps your car cool.
                                    Black dotted mesh fabric gives you complete privacy and its helps you
                                    to view outside properly while driving. Material used is in such way,
                                    that you don't face difficult while driving.
                                </p>
                            </div>
                            <div class="col-sm-4">
                                <p>
                                    UV Protection Sun Shades for Cars : These sun shades provide protection from harmful
                                    UV rays, improving the health and well-being of the occupants in the car. They can
                                    help reduce exposure to the sun's harmful rays, creating a safer and more
                                    comfortable driving environment.
                                </p>
                            </div>
                            <div class="col-sm-4">
                                <p>
                                    UV Protection Sun Shades for Cars : These sun shades provide protection from harmful
                                    UV rays, improving the health and well-being of the occupants in the car. They can
                                    help reduce exposure to the sun's harmful rays, creating a safer and more
                                    comfortable driving environment
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- products_section Ends -->

            <!-- <div class="company-history">
                <h2>Our Company History</h2>
                <div class="timeline">

                    <div class="event">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="Founded in 2005" />
                        <div class="event-text">
                            <h3>2012 - Founded</h3>
                            <p>We started as a small team with a big dream to revolutionize the tech industry.</p>
                        </div>
                    </div>

                    <div class="event">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="Product Launch 2010" />
                        <div class="event-text">
                            <h3>2013 - First Major Product Launch</h3>
                            <p>Released our first major software product which gained national attention.</p>
                        </div>
                    </div>

                    <div class="event">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="Global Expansion 2015" />
                        <div class="event-text">
                            <h3>2016 - Global Expansion</h3>
                            <p>Opened offices in 5 countries and served over 1 million customers.</p>
                        </div>
                    </div>

                    <div class="event">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="Digital Transformation 2020" />
                        <div class="event-text">
                            <h3>2020 - Digital Transformation</h3>
                            <p>Adopted AI and cloud technologies to modernize all platforms and services.</p>
                        </div>
                    </div>

                    <div class="event">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="Sustainability 2024" />
                        <div class="event-text">
                            <h3>2024 - Sustainability Focus</h3>
                            <p>Achieved carbon neutrality and launched green tech initiatives.</p>
                        </div>
                    </div>

                </div>
            </div> -->

            <div class="history-section">
                <h2>Our Journey</h2>
                <div class="history-timeline">

                    <div class="history-card">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="2005 - Founded" />
                        <div class="card-content">
                            <h3>2005</h3>
                            <p>Founded with a mission to innovate and inspire through technology.</p>
                        </div>
                    </div>

                    <div class="history-card">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="2010 - Product Launch" />
                        <div class="card-content">
                            <h3>2010</h3>
                            <p>Launched our first major product that made waves in the industry.</p>
                        </div>
                    </div>

                    <div class="history-card">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="2015 - Global Reach" />
                        <div class="card-content">
                            <h3>2015</h3>
                            <p>Expanded globally, reaching clients in over 20 countries.</p>
                        </div>
                    </div>

                    <div class="history-card">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="2020 - Tech Upgrade" />
                        <div class="card-content">
                            <h3>2020</h3>
                            <p>Embraced cloud computing and AI-driven solutions for our clients.</p>
                        </div>
                    </div>

                    <div class="history-card">
                        <img src="Images/HomeHeader/WhatsApp_Image1.jpeg" alt="2024 - Green Goals" />
                        <div class="card-content">
                            <h3>2024</h3>
                            <p>Committed to sustainability by integrating eco-friendly practices.</p>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Founder Story Section start -->
            <div class="founder-story">
                <div class="founder-text">
                    <h2>Our Origin Story</h2>
                    <p>When sun control films were banned in India, millions of car owners were left searching for a
                        safe and legal alternative to beat the heat and maintain privacy. It was then that <strong>Mr.
                            Jai Prakash Mandal</strong>, the visionary founder of H.N Enterprises, stepped forward with
                        a bold solution.</p>

                    <p>He invented the concept of <strong>car sunshades in India</strong>, offering a practical and
                        stylish replacement that met both comfort and legal standards.</p>

                    <p>Since its founding in <strong>2012</strong>, <strong>HN Brand</strong> has grown into a trusted
                        name in the industry — known for its <strong>custom-fit magnetic sunshades</strong>,
                        <strong>roller blinds</strong>, and <strong>premium printed sunshades</strong>. Today, we
                        proudly serve as OEM vendors to leading automotive brands, with a strong presence across
                        dealerships and retail markets nationwide.
                    </p>

                    <blockquote>
                        “There’s not a place for ‘no’ in my dictionary.”
                        <footer>— Mr. Jai Prakash Mandal, Founder, H.N Enterprises</footer>
                    </blockquote>

                    <p>His words continue to inspire our team as we innovate, improve, and lead the way in sunshade
                        solutions made for Indian roads and conditions.</p>
                </div>
                <div class="founder-image">
                    <img src="Images/Home/founder.png" alt="Mr. Jai Prakash Mandal, Founder" />
                </div>
            </div>
            <!-- Founder Story Section end -->


            <!-- history_section Starts -->
            <section class="history_section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <p>
                                Manufacturing Unit
                            </p>
                        </div>
                        <div class="col-md-12">
                            <img src="Images/company1.png" style="width:100%;" alt="history">
                        </div>
                    </div>
                </div>
            </section>
            <!-- history_section Ends -->


            <!-- partner_section Starts -->
            <section class="partner_section mt-5">
                <div class="container section-bg">
                    <div class="row mb-2">
                        <div class="common_heading">
                            <h4>Our Clients</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="boxed">
                            <div class="col-sm-12">

                                <div class="gallary-carousel-section">
                                    <owl-carousel-o [options]="gallary">

                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/bmw-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->

                                            </div>
                                        </ng-template>
                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/honda-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->
                                            </div>
                                        </ng-template>
                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/hyundai-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->
                                            </div>
                                        </ng-template>
                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/kia-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->
                                            </div>
                                        </ng-template>
                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/mahindra-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->
                                            </div>
                                        </ng-template>
                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/mg-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->
                                            </div>
                                        </ng-template>
                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/suzuki-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->
                                            </div>
                                        </ng-template>
                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/tata-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->
                                            </div>
                                        </ng-template>
                                        <ng-template carouselSlide>
                                            <div class="card-item">
                                                <div class="image-wrapper">
                                                    <img src="Images/Clients/volkswagen-logo.png" alt="">
                                                </div>
                                                <!-- <div class="caption">
                                                    <p>Lorem ipsum dolor sit amet</p>
                                                </div> -->
                                            </div>
                                        </ng-template>

                                    </owl-carousel-o>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- partner_section Ends -->


            <!--contact us section starts-->
            <section class="contact_us_section">
                <div class="container">
                    <div class="xxl_sub_container">
                        <div class="common_heading">
                            <h4>Contact us</h4>
                        </div>

                        <div class="contact_wrapper">
                            <div class="contact_row">
                                <div class="contact_left_col">
                                    <div class="contact_left_col_content">
                                        <div class="contact_flex_box">
                                            <div class="contact_icon"><svg width="30" height="30" viewBox="0 0 30 30"
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M29.9425 6.92188L19.42 17.4444C18.2467 18.6147 16.6572 19.2719 15 19.2719C13.3428 19.2719 11.7533 18.6147 10.58 17.4444L0.0575 6.92188C0.04 7.11938 0 7.29813 0 7.49438V22.4944C0.00198482 24.1514 0.661102 25.7399 1.83277 26.9116C3.00445 28.0833 4.59301 28.7424 6.25 28.7444H23.75C25.407 28.7424 26.9956 28.0833 28.1672 26.9116C29.3389 25.7399 29.998 24.1514 30 22.4944V7.49438C30 7.29813 29.96 7.11938 29.9425 6.92188Z"
                                                        fill="white" />
                                                    <path
                                                        d="M17.6522 15.6825L29.0697 4.26375C28.5166 3.34665 27.7365 2.58755 26.8047 2.05966C25.8728 1.53178 24.8207 1.25293 23.7497 1.25H6.24969C5.17871 1.25293 4.12656 1.53178 3.19472 2.05966C2.26288 2.58755 1.48279 3.34665 0.929688 4.26375L12.3472 15.6825C13.0517 16.3841 14.0054 16.7781 14.9997 16.7781C15.994 16.7781 16.9477 16.3841 17.6522 15.6825Z"
                                                        fill="white" />
                                                </svg>
                                            </div>
                                            <div class="contact_content">
                                                <a href="mailto:hnenterprises19@gmail.com">hnenterprises19&#64;gmail.com
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="contact_mid_col">
                                    <div class="contact_mid_col_content">
                                        <div class="contact-count-wrapper">
                                            <div class="contact-count-svg">
                                                <svg width="102" height="102" viewBox="0 0 102 102" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="51" cy="51" r="51" fill="white" />
                                                    <path
                                                        d="M64.8451 28.7012C60.4795 22.5933 54.1314 19.7459 47.5082 19.7461C47.5082 19.7461 31.2873 19.7459 26.4837 34.5163C24.7135 39.9597 25.1056 45.8711 27.2537 51.1721C27.9964 53.0053 28.9835 54.9934 30.2842 56.9043C34.4724 63.0578 47.5084 79.8618 47.5084 79.8618H50.3418C53.9802 74.7216 63.1407 57.6455 65.884 52.1708C69.3289 45.2963 69.8585 35.7156 64.8451 28.7012ZM50.2133 56.0239C42.5611 56.0239 36.3577 49.7139 36.3577 41.9302C36.3577 34.1466 42.5611 27.8366 50.2133 27.8366C57.8655 27.8366 64.0689 34.1466 64.0689 41.9302C64.0691 49.7139 57.8657 56.0239 50.2133 56.0239Z"
                                                        fill="#215EA8" />
                                                    <path opacity="0.4"
                                                        d="M64.8451 28.7012C60.4795 22.5933 54.1314 19.7459 47.5082 19.7461C47.5082 19.7461 31.2873 19.7459 26.4837 34.5163C24.7135 39.9597 25.1056 45.8711 27.2537 51.1721C27.9964 53.0053 28.9835 54.9934 30.2842 56.9043C34.4724 63.0578 47.5084 79.8618 47.5084 79.8618H50.3418C53.9802 74.7216 63.1407 57.6455 65.884 52.1708C69.3289 45.2963 69.8585 35.7156 64.8451 28.7012ZM50.2133 56.0239C42.5611 56.0239 36.3577 49.7139 36.3577 41.9302C36.3577 34.1466 42.5611 27.8366 50.2133 27.8366C57.8655 27.8366 64.0689 34.1466 64.0689 41.9302C64.0691 49.7139 57.8657 56.0239 50.2133 56.0239Z"
                                                        fill="black" />
                                                    <path
                                                        d="M67.6966 28.8184C63.3311 22.7105 56.983 19.8631 50.3597 19.8633C50.3597 19.8633 34.1389 19.8631 29.3353 34.6335C27.5651 40.0769 27.9571 45.9883 30.1052 51.2893C30.8479 53.1224 31.835 55.1105 33.1358 57.0215C37.3239 63.175 50.3599 79.979 50.3599 79.979C50.3599 79.979 65.4206 58.9033 68.7358 52.288C72.1805 45.4132 72.7101 35.8326 67.6966 28.8184ZM50.2312 56.1411C42.545 56.1583 36.3469 49.9145 36.3756 42.0472C36.404 34.2636 42.5791 27.9536 50.2312 27.9536C57.8834 27.9536 64.0925 34.2636 64.0868 42.0472C64.0813 49.8558 57.8646 56.1238 50.2312 56.1411Z"
                                                        fill="#215EA8" />
                                                    <path
                                                        d="M50.2089 27.8359C44.1805 27.8359 39.0539 31.7532 37.1484 37.2209C39.0135 33.037 43.1524 30.1252 47.9626 30.1252C54.5189 30.1252 59.8337 35.5313 59.8337 42.2001C59.8337 48.869 54.5189 54.2751 47.9626 54.2751C44.1559 54.2751 40.7701 52.4504 38.5978 49.6162C41.0701 53.4723 45.3454 56.0234 50.2089 56.0234C57.861 56.0234 64.0644 49.7135 64.0644 41.9297C64.0646 34.1461 57.8612 27.8359 50.2089 27.8359Z"
                                                        fill="#215EA8" />
                                                    <path opacity="0.4"
                                                        d="M50.2089 27.8359C44.1805 27.8359 39.0539 31.7532 37.1484 37.2209C39.0135 33.037 43.1524 30.1252 47.9626 30.1252C54.5189 30.1252 59.8337 35.5313 59.8337 42.2001C59.8337 48.869 54.5189 54.2751 47.9626 54.2751C44.1559 54.2751 40.7701 52.4504 38.5978 49.6162C41.0701 53.4723 45.3454 56.0234 50.2089 56.0234C57.861 56.0234 64.0644 49.7135 64.0644 41.9297C64.0646 34.1461 57.8612 27.8359 50.2089 27.8359Z"
                                                        fill="black" />
                                                </svg>
                                            </div>

                                            <div class="contact-count-title">
                                                <h3>Faridabad, Haryana - 121002 </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="contact_right_col">
                                    <div class="contact_right_col_content">
                                        <div class="contact_flex_box">
                                            <div class="contact_icon"><svg width="30" height="30" viewBox="0 0 30 30"
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_13290_22924)">
                                                        <path
                                                            d="M28.7494 13.7522C28.4179 13.7522 28.0999 13.6205 27.8655 13.3861C27.6311 13.1517 27.4994 12.8337 27.4994 12.5022C27.4967 9.85085 26.4423 7.30885 24.5675 5.43406C22.6927 3.55927 20.1507 2.50485 17.4994 2.5022C17.1679 2.5022 16.8499 2.3705 16.6155 2.13608C16.3811 1.90166 16.2494 1.58372 16.2494 1.2522C16.2494 0.920679 16.3811 0.602737 16.6155 0.368316C16.8499 0.133896 17.1679 0.00219958 17.4994 0.00219958C20.8135 0.00583908 23.9908 1.32397 26.3342 3.66738C28.6776 6.0108 29.9958 9.18811 29.9994 12.5022C29.9994 12.8337 29.8677 13.1517 29.6333 13.3861C29.3989 13.6205 29.0809 13.7522 28.7494 13.7522ZM24.9994 12.5022C24.9994 10.5131 24.2092 8.60542 22.8027 7.1989C21.3962 5.79238 19.4885 5.0022 17.4994 5.0022C17.1679 5.0022 16.8499 5.1339 16.6155 5.36832C16.3811 5.60274 16.2494 5.92068 16.2494 6.2522C16.2494 6.58372 16.3811 6.90166 16.6155 7.13608C16.8499 7.3705 17.1679 7.5022 17.4994 7.5022C18.8255 7.5022 20.0972 8.02898 21.0349 8.96667C21.9726 9.90435 22.4994 11.1761 22.4994 12.5022C22.4994 12.8337 22.6311 13.1517 22.8655 13.3861C23.0999 13.6205 23.4179 13.7522 23.7494 13.7522C24.0809 13.7522 24.3989 13.6205 24.6333 13.3861C24.8677 13.1517 24.9994 12.8337 24.9994 12.5022ZM27.7281 27.7072L28.8656 26.396C29.5897 25.6696 29.9962 24.6859 29.9962 23.6603C29.9962 22.6348 29.5897 21.651 28.8656 20.9247C28.8269 20.886 25.8194 18.5722 25.8194 18.5722C25.0976 17.8851 24.1388 17.5025 23.1423 17.5039C22.1457 17.5053 21.188 17.8906 20.4681 18.5797L18.0856 20.5872C16.1409 19.7823 14.3742 18.6012 12.8872 17.1116C11.4002 15.622 10.2222 13.8534 9.42064 11.9072L11.4206 9.5322C12.1103 8.81242 12.496 7.85455 12.4976 6.8577C12.4993 5.86086 12.1167 4.90173 11.4294 4.1797C11.4294 4.1797 9.11314 1.17595 9.07439 1.1372C8.36121 0.419385 7.39424 0.0109771 6.38243 0.000218061C5.37061 -0.010541 4.39518 0.377213 3.66689 1.0797L2.22939 2.3297C-6.26311 12.1822 12.0244 30.3285 22.2019 30.0022C23.2296 30.0082 24.2481 29.8081 25.1973 29.414C26.1464 29.0198 27.007 28.4395 27.7281 27.7072Z"
                                                            fill="white" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_13290_22924">
                                                            <rect width="30" height="30" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>

                                            </div>
                                            <div class="contact_content">
                                                <a href="tel:+91 - 9717060536">+91 - 9717060536
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>

                    </div>
                </div>
            </section>
            <!--contact us section end-->


        </div>
    </div>
</div>
<!-- bottom_section Ends -->

<app-footer />